/** @format */

import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PasswordResetForm } from '../components/PasswordResetForm';

/**
 * PasswordResetContainer
 * Container component for the password reset flow
 */
export const PasswordResetContainer: React.FC = () => {
  return (
    <>
      <PasswordResetForm />
      <ToastContainer />
    </>
  );
};

export default PasswordResetContainer;
